// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__3AgOu","actionsCol":"EnrolledClinics_actionsCol__-dAJm"};